module.exports = __webpack_public_path__ + "img/Retail20.487ac62a.png";